module.exports = __webpack_public_path__ + "static/media/993940.ece9d57b.png";